import FormValidationStrategy from "../strategy/FormValidationStrategy.js";

export default class EmailValidationStrategy extends FormValidationStrategy {
  validate(valueString, isRequired) {
    const value = valueString.toString().trim(),
      emailRegexp = /^([\w\.\-]+)@([\w\-]+)((\.(\w){2,3})+)$/;

    let isValid = false;

    if (isRequired && !value.length) {
      return {
        isValid,
        message: this.loadErrorMessage("empty", "E-mail"),
      };
    }

    if (value.length && !emailRegexp.test(value)) {
      return {
        isValid,
        message: this.loadErrorMessage("regexp", "E-mail"),
      };
    }

    isValid = true;

    return {
      isValid,
      message: "",
    };
  }
}
